import React, { useEffect, useContext, useRef } from 'react';

import Iframe from 'react-iframe'

import {
    Container
} from '@material-ui/core';

import {
} from '../../common';

import {
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { ApiRoutes } from '../../contexts/RestApiContext';
import { AuthContext } from '../../contexts/AuthContext';
import { NavContext, NavRoutes } from '../../contexts/NavContext';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: "center"
    }
}));

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        pageIsReady,
        setPageIsReady,
        isBusy,
        setIsBusy
    } = useContext(PageContext);

    const {
        getToken
    } = useContext(AuthContext);

    const windowResizeHandler = (e) => {
        if (containerDiv.current) {
            const htmlDiv = containerDiv.current;
            const height = window.innerHeight - (htmlDiv.offsetTop);
            htmlDiv.style.height = `${height}px`;
        }
    }

    const containerDiv = useRef(null);
    useEffect(() => {
        if (containerDiv.current) {
            const htmlDiv = containerDiv.current;
            const height = window.innerHeight - (htmlDiv.offsetTop);
            htmlDiv.style.height = `${height}px`;
        }
    }, []);

    useEffect(() => {
        window.addEventListener("resize", windowResizeHandler);
        return () => {
            window.addEventListener("resize", null);
        }
    }, []);

    return (
        <div ref={containerDiv}>
            <Iframe url={ApiRoutes.Bookings.GetBookingsUrl({ token: getToken() })}
                width="100%"
                height="100%"
                display="initial"
                position="relative"
            />
        </div>
    );
}

export const HomePage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}